import React, { useEffect, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Log from '../../Services/Log';
import DateService from '../../Services/DateService';
import lumiLogo from '../../../src/assets/images/main_logo.png';
import lumiBg from '../../../src/assets/images/lumi_bg.png';
import demoSignature from '../../../src/assets/images/signature.png';
import lumiFooter from '../../../src/assets/images/lumi_footer.png';
import './invoice.scss'
import downloadIcon from '../../../src/assets/images/download_icon.svg'

import { Button } from 'antd';

const Invoice = ({ paymentLogs, preview }) => {
    const [previewStatus, setPreviewStatus] = useState(true)
    const invoiceRef = useRef();

    console.log('payment logs', paymentLogs)

    const downloadInvoice = async () => {
        const element = invoiceRef.current;

        // Use html2canvas to render the element as a canvas
        const canvas = await html2canvas(element, {
            useCORS: true,
            logging: true,
            scale: 2,
            allowTaint: true,
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        // Extract and add clickable links
        // const existingLinks = extractLinksFromInvoice(element);
        // existingLinks.forEach((link) => {
        //     // Calculate position relative to the container
        //     const pdfPosition = {
        //         x: (link.x / element.offsetWidth) * imgWidth, // Adjust based on element's width
        //         y: (link.y / element.offsetHeight) * imgHeight, // Adjust based on element's height
        //         width: (link.width / element.offsetWidth) * imgWidth, // Scale width
        //         height: (link.height / element.offsetHeight) * imgHeight, // Scale height
        //     };

        //     // Debugging: Optional highlight to visualize clickable area
        //     pdf.setFillColor(0, 255, 0, 0.3); // Green with 30% opacity
        //     pdf.rect(pdfPosition.x, pdfPosition.y, pdfPosition.width, pdfPosition.height, 'F');

        //     // Add clickable link to PDF
        //     pdf.link(pdfPosition.x, pdfPosition.y, pdfPosition.width, pdfPosition.height, {
        //         url: link.url,
        //     });
        // });

        const existingLinks = extractLinksFromInvoice(element);
        existingLinks.forEach((link) => {
            // Calculate position relative to the container
            const pdfPosition = {
                x: (link.x / element.offsetWidth) * imgWidth, // Adjust based on element's width
                y: (link.y / element.offsetHeight) * imgHeight, // Adjust based on element's height
                width: (link.width / element.offsetWidth) * imgWidth, // Scale width
                height: (link.height / element.offsetHeight) * imgHeight, // Scale height
            };

            // Add clickable link to PDF
            pdf.link(pdfPosition.x, pdfPosition.y, pdfPosition.width, pdfPosition.height, {
                url: link.url,
            });
        });



        pdf.save('invoice.pdf');
    };

    // Function to extract links from the invoice content
    const extractLinksFromInvoice = (element) => {
        const links = [];
        const anchorTags = element.querySelectorAll('a');
        const containerRect = element.getBoundingClientRect(); // Get the container's position and size

        anchorTags.forEach((anchor) => {
            const rect = anchor.getBoundingClientRect(); // Get the anchor's position and size
            links.push({
                url: anchor.href,
                x: rect.left - containerRect.left, // X position relative to the container
                y: rect.top - containerRect.top,  // Y position relative to the container
                width: rect.width,
                height: rect.height,
            });
        });

        return links;
    };


    // Function to extract links from the invoice content



    let purchasedDate = DateService.formatDateCustom(paymentLogs?.order_date);

    // useEffect(() => {
    //     if (!previewStatus) {
    //         preview(previewStatus)
    //     }
    // }, [previewStatus])

    return (
        <div>
            <div className='button_holder'>
                <Button className="download_button" type="default" onClick={downloadInvoice}>
                    <img className="icon" src={downloadIcon} alt="" />
                </Button>
            </div>
            <div
                className="wrap main_wrap invoice_wrap"
                ref={invoiceRef}
                style={{
                    fontFamily: "'Poppins', sans-serif",
                    width: '100%',
                    background: `${lumiBg} no-repeat center / 56%`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionX: 'center',
                    backgroundSize: '56%',
                    backgroundPosition: 'right bottom',
                }}
            >
                <table className="wrap top" role="presentation" align="center">
                    {/* Header Section */}
                    <tr className="header">
                        <td style={{ width: "50%" }} className='mob_block'>
                            <h1 style={{ textTransform: "uppercase", fontWeight: "bold", fontSize: "1.5rem", lineHeight: "1.5" }}>
                                Tax Invoice
                            </h1>
                            <span>(Original for Recipient)</span>
                        </td>
                        <td style={{ width: "50%", textAlign: "right" }} className='mob_block'>
                            <a href="https://lumimatrimony.com/" className='logo' target='_blank'>
                                <img
                                    src={lumiLogo}
                                    alt="Lumi Matrimony Logo"
                                    width="140"
                                />
                            </a>
                        </td>
                    </tr>

                    {/* Company and Billing Information Section */}
                    <tr>
                        <td style={{ width: "50%", verticalAlign: "top" }} className='mob_block'>
                            <strong>FlipTree Technologies (India) Private Limited</strong><br />
                            4/461, 2nd Floor, Suite No.1327, Valamkottil Towers,<br />
                            Judgemukku, Kakkanad, Kochi, Kerala - 682021<br />
                            <ul className="info">
                                <li>CIN: U72500KL2020FTC062667</li>
                                <li>PAN: AAECF1199A</li>
                                <li>GSTIN: 32AAECF1199A1Z4</li>
                            </ul>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "top" }} className="bill_to mob_block">
                            <strong>Bill To</strong><br />
                            <span>{paymentLogs.billing_address?.name || ''}</span><br />
                            {paymentLogs.billing_address?.addressLine2 && (
                                <>
                                    <span>{paymentLogs.billing_address?.addressLine2}</span><br />
                                </>
                            )}
                            {paymentLogs.billing_address?.address && (
                                <>
                                    <span>{paymentLogs.billing_address?.address}</span><br />
                                </>
                            )}
                             {paymentLogs.billing_address?.state?.label && (
                                <>
                                    <span>{paymentLogs.billing_address?.state?.label}</span><br />
                                </>
                            )}
                            <span>
                                {`${paymentLogs.billing_address?.city?.label || ''} ${paymentLogs.billing_address?.pincode || ''}`}
                            </span><br />
                            <span>Phone: {'+91 ' + paymentLogs?.phone || ''}</span>
                        </td>
                    </tr>

                    {/* Invoice Details Section */}
                    <tr>
                        <td colSpan="2" style={{ textAlign: "left", paddingTop: "2em", paddingBottom: "1em" }}>
                            <ul className="info">
                                <li><strong>Invoice No:</strong> {paymentLogs.invoice_number || ''}</li>
                                <li><strong>Invoice Date:</strong> {DateService.formatDateCustom(paymentLogs.order_date) || ''}</li>
                            </ul>
                        </td>
                    </tr>

                    {/* Table of Items */}
                    <tr>
                        <td colSpan="2">
                            <table className="content">
                                <thead>
                                    <tr>
                                        <th>Sl. No</th>
                                        <th>Description</th>
                                        <th>SAC</th>
                                        <th>Unit Price</th>
                                        <th>Qty</th>
                                        <th>Taxable Amount</th>
                                        {paymentLogs.igst_value && paymentLogs.igst_amount ? (
                                            <th>IGST {paymentLogs.igst_value}%</th>
                                        ) : (
                                            <>
                                                <th>CGST {paymentLogs.cgst}%</th>
                                                <th>SGST {paymentLogs.sgst}%</th>
                                            </>
                                        )}
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td style={{ textTransform: "capitalize" }}>
                                            Lumi Ads ({paymentLogs?.product_title || ''})
                                        </td>
                                        <td>998399</td>
                                        <td>₹{paymentLogs.unit_price}</td>
                                        <td>1</td>
                                        <td>₹{paymentLogs.unit_price}</td>
                                        {paymentLogs.igst_value && paymentLogs.igst_amount ? (
                                            <td>{paymentLogs.igst_amount}</td>
                                        ) : (
                                            <>
                                                <td>₹{paymentLogs.cgst_amount}</td>
                                                <td>₹{paymentLogs.sgst_amount}</td>
                                            </>
                                        )}
                                        <td>₹{paymentLogs.amount}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="3" style={{ textAlign: "left" }}>
                            <strong>Transaction ID:</strong> {paymentLogs.transactionId}
                        </td>
                    </tr>

                    <tr>
                        <td style={{ width: "60%", verticalAlign: "top" }} className="signature-part mob_block">
                            <ul className="info">
                                <li>
                                    <strong>Payment Method:</strong> <span style={{ textTransform: "uppercase" }}>
                                        {paymentLogs.payment_method?.replaceAll('_', ' ')}
                                    </span>
                                </li>
                                <li><strong>Purchase Date:</strong> {DateService.formatDateCustom(paymentLogs.order_date)}</li>
                                <li>
                                    <strong>Purchased Product(s):</strong> <span style={{ textTransform: "capitalize" }}>
                                        Lumi Ads ({paymentLogs?.product_title || ''})
                                    </span>
                                </li>
                            </ul>
                        </td>
                        <td style={{ width: "40%", textAlign: "right" }} className="signature-part mob_block">
                            <strong>For FlipTree Technologies (India) Private Limited:</strong><br />
                            <img
                                src={demoSignature}
                                alt="Signature"
                                width="150"
                            /><br />
                            <strong>Authorized Signature</strong>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <a href="/terms" target="_blank" className="mb-1 text_red">Terms and Conditions</a>
                        </td>
                    </tr>

                    {/* Footer Section */}
                    <tr className="footer">
                        <td colSpan="2">
                            Whether tax payable under Reverse Charge - No<br /><br />
                            <a href="https://lumimatrimony.com" target='_blank' className="terms-link">www.lumimatrimony.com</a>
                        </td>
                    </tr>
                </table>

            </div>

        </div>

    );
};

export default Invoice;
